import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sheba-profile-icon',
  templateUrl: 'profile.svg',
  host: {
    class: 'contents'
  },
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileIcon { }
